const STATS_TAG_TYPES = {
  STATS_GET: "STATS_GET"
};

export const STATS_TAGS = Object.values(STATS_TAG_TYPES);
export default STATS_TAG_TYPES;
